export default "__VITE_ASSET__508ba021__"